"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_APPOINTMENT_REQUEST_EXAMPLE = exports.searchAppointmentRequestSchema = exports.appointmentSearchCriteriaSchema = void 0;
/**
 * `POST /appointments/search` — closes a real, disclosed gap: no GET/
 * list/search endpoint existed for Appointment at all
 * (`AppointmentLookupPanel` could only act on a known id). Mirrors
 * `AppointmentSearchCriteria`/`AppointmentSearchSpecification`
 * (`backend/src/modules/appointment/appointment/appointment.repository.ts`,
 * frozen) exactly — same shape, same "one composable criteria object"
 * convention `patientSearchCriteriaSchema` already established for
 * Patient Identity.
 */
const zod_1 = require("zod");
exports.appointmentSearchCriteriaSchema = zod_1.z.object({
    doctorId: zod_1.z.string().uuid().optional(),
    departmentId: zod_1.z.string().uuid().optional(),
    branchId: zod_1.z.string().uuid().optional(),
    patientId: zod_1.z.string().uuid().optional(),
    status: zod_1.z.enum(['PENDING_CONFIRMATION', 'CONFIRMED', 'CHECKED_IN', 'COMPLETED', 'CANCELLED', 'NO_SHOW']).optional(),
    scheduledFrom: zod_1.z.coerce.date().optional(),
    scheduledTo: zod_1.z.coerce.date().optional(),
    /**
     * Partial, case-insensitive match on the printed appointment number
     * (`APT<YYYY><6 digits>`). `contains`, because the desk reads it off a slip
     * and types the distinctive tail far more often than the whole thing.
     */
    appointmentNumberContains: zod_1.z.string().min(1).max(30).optional(),
    /**
     * NEW or REPEAT patient — the register's two tabs (desk, 2026-09-08: "need
     * two tabs under this register New pateint and repreat patient wise").
     *
     * THE SAME RULE THE DASHBOARD REPORTS, not a second one. `consultation-classifier.ts`
     * is the single definition — a recorded `revisitType` wins, a booking with no
     * patient record is NEW because there is no history to have, otherwise NEW
     * means this is the patient's earliest non-cancelled booking. Everything that
     * is not NEW is REPEAT here, which is exactly the binary the front-desk
     * report already prints ("New = no earlier non-cancelled booking; everything
     * else is repeat").
     *
     * A SECOND DEFINITION WOULD BE THE DEFECT. Two screens in one product
     * disagreeing about who is a new patient is worse than neither having the
     * filter, because both look authoritative.
     */
    visitType: zod_1.z.enum(['NEW', 'REPEAT']).optional(),
    /**
     * DROP UNBILLED DRAFTS — the Appointment Register's rule.
     *
     * Desk, 2026-09-09: "this register showing pending payment state remove those
     * beacuse now untill payment everything is draft right..."
     *
     * They are right, and it is the same rule the dashboards and reports took
     * earlier the same day (`appointment-reportability.ts`): until the
     * consultation is billed the booking holds no slot and is in no figure, so a
     * REGISTER — a list read as the record of what happened — must not carry it
     * either.
     *
     * OPT-IN, AND THAT IS DELIBERATE. The Lookup tab searches the same endpoint
     * and MUST still find an unbilled booking: it is the screen a clerk uses to
     * pull one up and take the money. Defaulting this on would make an unpaid
     * booking unfindable, which is the one outcome worse than showing it in a
     * register.
     */
    excludeUnbilled: zod_1.z.coerce.boolean().optional(),
    /**
     * FOLLOW-UP OR REPEAT — the booking's OWN recorded revisit type.
     *
     * Desk, 2026-09-09: "in this page need follow-up tab also.... only followup
     * pateit list should show."
     *
     * NOT `visitType`, AND THE DISTINCTION IS THE WHOLE POINT. `visitType` is a
     * DERIVED classification — is this the patient's earliest non-cancelled
     * booking — and every appointment has one. `revisitType` is a FACT recorded
     * on the booking when the desk raised it as a follow-up or a repeat, and most
     * appointments have none at all. A clerk asking for "follow-ups" wants the
     * ones somebody marked as such, not everyone who has been here before.
     */
    revisitType: zod_1.z.enum(['FOLLOW_UP', 'REPEAT']).optional(),
});
exports.searchAppointmentRequestSchema = zod_1.z.object({
    criteria: exports.appointmentSearchCriteriaSchema,
    pagination: zod_1.z.object({ page: zod_1.z.number().int().positive(), limit: zod_1.z.number().int().positive().max(100) }),
    sort: zod_1.z.string().optional(),
});
exports.SEARCH_APPOINTMENT_REQUEST_EXAMPLE = {
    criteria: { status: 'CONFIRMED' },
    pagination: { page: 1, limit: 20 },
    sort: 'scheduledAt:desc',
};
//# sourceMappingURL=appointment-search.request.js.map